import React, { useState } from 'react';
import axios from 'axios';

const REVIEW_ACCESS_URL = 'https://sonora-ai-8c2ca83436a1.herokuapp.com/user/review-access';
const PROFILE_ID_PATTERN = /^\d{4,19}$/;

const Faucet = () => {
    const [profileId, setProfileId] = useState('');
    const [code, setCode] = useState('');
    const [message, setMessage] = useState('');
    const isValid = PROFILE_ID_PATTERN.test(profileId) && code.trim().length > 0;

    const handleClick = async () => {
        if (!isValid) return;
        try {
            const response = await axios.post(REVIEW_ACCESS_URL, { profileId, code: code.trim() });
            setMessage(response.data.message);
        } catch (error) {
            setMessage(error.response ? error.response.data.message : 'An error occurred');
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
                <h1 className="text-2xl font-bold mb-6 text-center">Sumo Test Credits</h1>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="profileId">
                        Profile ID
                    </label>
                    <input
                        type="text"
                        id="profileId"
                        value={profileId}
                        onChange={(e) => setProfileId(e.target.value.trim())}
                        placeholder="1234567890"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="accessCode">
                        Access code
                    </label>
                    <input
                        type="text"
                        id="accessCode"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="Access code"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                </div>
                <button
                    onClick={handleClick}
                    disabled={!isValid}
                    className={`w-full py-3 px-6 rounded-lg font-semibold text-base transition-all duration-200 transform active:scale-95 shadow-md ${isValid
                            ? 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white shadow-blue-200'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                >
                    Take Test Credit
                </button>
                {message && <p className="mt-4 text-center text-red-500">{message}</p>}
            </div>
        </div>
    );
};

export default Faucet;